module.exports = __webpack_public_path__ + "static/media/billing.1a303b35.svg";